import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';

import { filter, Subscription, tap } from 'rxjs';
import { MetadataService } from './services/metadata.service';
import { AuthenticationResult, EventType } from '@azure/msal-browser';
import { LiveAlertsService } from './components/alerts/services/live-alerts.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  isIframe = false;

  private subscription = new Subscription();

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private metadataService: MetadataService,
    private liveAlertsService: LiveAlertsService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.msalService
        .handleRedirectObservable()
        .pipe(
          tap(() => {
            if (this.msalService.instance.getAllAccounts().some(({ authorityType }) => authorityType !== 'ADFS')) {
              localStorage.clear();
              this.msalService.instance.setActiveAccount(null);
              this.msalService.loginRedirect();
            }
          })
        )
        .subscribe({
          complete: () => {
            // The warm-reload case (MSAL already has a cached active account — see the comment
            // below) has to wait for MSAL's own redirect handling to fully settle first;
            // calling acquireTokenSilent() (which connect() does, for the hub token) while that
            // interaction is still in flight throws MSAL's "interaction_in_progress" error.
            // handleRedirectObservable() completing is exactly that signal, and resolves near-
            // immediately when there's no redirect response to process.
            if (this.msalService.instance.getActiveAccount()) {
              this.liveAlertsService.connect();
            }
          }
        })
    );
    this.subscription.add(
      this.msalBroadcastService.msalSubject$
        .pipe(
          filter(msg => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.SSO_SILENT_SUCCESS),
          tap(result => {
            const payload = result.payload as AuthenticationResult;
            this.msalService.instance.setActiveAccount(payload.account);
            // Needs a real token (SignalR doesn't ride through MsalInterceptor), so this waits
            // for an actual login event rather than firing unconditionally like getMetadata()
            // below.
            this.liveAlertsService.connect();
          })
        )
        .subscribe()
    );
    this.subscription.add(this.metadataService.getMetadata().subscribe());
    this.isIframe = window !== window.parent && !window.opener;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
